module.exports = __webpack_public_path__ + "static/media/styledmenu-hamburger.cc1c400c.svg";